import "reflect-metadata";
import {inject, injectable} from "inversify";
import {IoRepository} from "@dropDesk/domain/repositories/io/io.repository";

@injectable()
export class UrlToBlobUseCase {
  private _repository: IoRepository;

  constructor(@inject(IoRepository) repository: IoRepository) {
    this._repository = repository;
  }

  public call(url: string): Promise<Blob> {
    return this._repository.urlToBlob(url);
  }
}
